import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class OgDataService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly document = inject(DOCUMENT);

  public setOgData(ogTitle: string, ogUrl: string): void {
    this.title.setTitle(ogTitle);
    this.upsertMetaName('description', ogTitle);
    this.upsertMetaName('robots', 'index, follow');
    this.upsertMetaProperty('og:title', ogTitle);
    this.upsertMetaProperty('og:url', ogUrl);
    this.upsertCanonicalLink(ogUrl);
  }

  private upsertMetaName(name: string, content: string): void {
    this.meta.updateTag({
      name,
      content,
    });
  }

  private upsertMetaProperty(property: string, content: string): void {
    this.meta.updateTag({
      property,
      content,
    });
  }

  private upsertCanonicalLink(url: string): void {
    const head = this.document.head;
    const existing = head.querySelector('link[rel="canonical"]');

    if (existing) {
      existing.setAttribute('href', url);
      return;
    }

    const link = this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    head.appendChild(link);
  }
}
